export const migrated = {
  le_lien_de_votre_annonce_airbnb_est_obligatoire_:
    "Le lien de votre annonce airbnb est obligatoire",
  la_note_airbnb_doit__tre_au_minimum_de_4_5_:
    "La note airbnb doit tre au minimum de 4 5",
  compte_cr______v_rifiez_votre_email_pour_activer_votre_acc_s_au_club_:
    "Compte cr  vérifiéez votre email pour activer votre acc s'au club",
  club_r_serv__aux_h_tes_airbnb_not_s_4_5__:
    "Club r serv aux hôtes airbnb not s'4 5",
  comparez_vos_gains_r_els: "Comparez vos gains r els",
  le_mod_le_traveltrok_est_gagnant_gagnant___le_voya:
    "Le mod le traveltrok est gagnant gagnant le voya",
  votre_prix_sur_les_autres_sites: "Votre prix sur les autres sites",
  diminuer_le_prix: "Diminuer le prix",
  augmenter_le_prix: "Augmenter le prix",
  net_pour_vous: "Net pour vous",
  de_commissions: "De commissions",
  prix_pay__par_le_voyageur: "Prix pay par le voyageur",
  revenu___d_clarer__imp_ts_: "Revenu d'clarer impôts",
  vous_d_clarez_100__du_prix____commissions__:
    "Vous d'clarez 100 du prix commissions",
  de_frais_h_te: "De frais hôte",
  __0__compar____booking_: "0 compar booking",
  mod_le_frais_h_te__depuis_25_____: "Mod le frais hôte depuis 25",
  vous_d_clarez_100__du_prix_voyageur_: "Vous d'clarez 100 du prix voyageur",
  strat_gie_gagnante: "Strat gie gagnante",
  prix_voyageur: "Prix voyageur",
  _5__pour_le_voyageur: "5 pour le voyageur",
  le_meilleur_des_deux_mondes: "Le meilleur des deux mondes",
  avantage_fiscal: "Avantage fiscal",
  vous_d_clarez_moins__vous_payez_moins_d____imp_ts_:
    "Vous d'clarez moins vous payez moins d' impôts",
  sc_nario___traveltrok_applique_5__de_frais_voyageu:
    "Sc nario traveltrok applique 5 de frais voyageu",
  appartement: "Appartement",
  maison: "Maison",
  inclut_villa_chalet: "Inclut villa chalet",
  loft: "Loft",
  luxe: "Luxe",
  insolite: "Insolite",
  autre: "Autre",
  campagne: "Campagne",
  mer: "Mer",
  montagne: "Montagne",
  au_dessus_de_500_nuit: "Au dessus de 500€/nuit",
  aucun_resultat_dynamique: "Aucun resultat dynamique",
  service_de_localisation_indisponible__r_essayez_da:
    "Service de localisation indisponible, réessayez dans un instant",
  quel_type_de_logement_souhaitez_vou:
    "Quel type de logement souhaitez-vous proposer ?",
  choisissez_la_cat_gorie_qui_d_crit_le_mieux_votre_:
    "Choisissez la catégorie qui décrit le mieux votre logement",
  quel_est_le_cadre_du_logement__: "Quel est le cadre du logement ?",
  o__est_situ__votre_logement__: "Où est situé votre logement ?",
  pays_europ_en_de_r_f_rence: "Pays européen de référence",
  ville__village__code_postal___: "Ville, village, code postal...",
  recherche_en_cours___: "Recherche en cours...",
  recherche___: "Recherche...",
  localiser: "Localiser",
  nous_utiliserons_cette_adresse_pour_localiser_votr:
    "Nous utiliserons cette adresse pour localiser votre logement",
  localis_: "Localisé",
  _copy__openstreetmap_france: "© OpenStreetMap France",
  emplacement_valid_: "Emplacement validé",
  d_crivez_votre_logement: "Décrivez votre logement",
  donnez_envie_aux_voyageurs_de_s_journer_chez_vous_:
    "Donnez envie aux voyageurs de séjourner chez vous",
  titre_de_l__annonce: "Titre de l'annonce",
  ex__charmant_studio_au_c_ur_de_paris: "Ex : Charmant studio au cœur de Paris",
  soyez_concis_et_accrocheur: "Soyez concis et accrocheur",
  description_d_taill_e: "Description détaillée",
  parlez_de_votre_logement__du_quartier__des__quipem:
    "Parlez de votre logement, du quartier, des équipements...",
  mentionnez_les_points_forts: "Mentionnez les points forts",
  voyageurs: "Voyageurs",
  chambres: "Chambres",
  lits: "Lits",
  salles_de_bain: "Salles de bain",
  d_tails_du_logement: "Détails du logement",
  donnez_plus_d__informations_sur_la_capacit__d__acc:
    "Donnez plus d'informations sur la capacité d'accueil",
  surface__m__: "Surface (m²)",
  ex__85: "Ex: 85",
  ajoutez_des_photos: "Ajoutez des photos",
  mettez_en_valeur_votre_logement_avec_de_belles_ima:
    "Mettez en valeur votre logement avec de belles images",
  glissez_vos_photos_ici: "Glissez vos photos ici",
  parcourez_vos_fichiers: "Parcourez vos fichiers",
  jpg__png_jusqu____5_mo: "JPG, PNG (jusqu'à 5 Mo)",
  d_j__en_ligne: "Déjà en ligne",
  __uploader: "À uploader",
  fixez_votre_prix: "Fixez votre prix",
  vous_pourrez_le_modifier___tout_moment_:
    "Vous pourrez le modifier à tout moment",
  par_nuit: "Par nuit",
  aper_u_de_votre_annonce: "Aperçu de votre annonce",
  titre_de_votre_annonce: "Titre de votre annonce",
  nouveau: "Nouveau",
  localisation: "Localisation",
  suppression_du_profil__tapez_supprimer_puis_confirmez__si_la_suppression_compl_te_est_impossible__votre_profil_sera_mis_en_pause_et_masque_:
    "Suppression du profil tapez supprimer puis confirmez si la suppression complète est impossible votre profil sera mis en pause et masque",
  suppression_compl_te_indisponible__profil_mis_en_pause_et_masque_:
    "Suppression complète indisponible profil mis en pause et masque",
  preferences: "Preferences",
  gerez_vos_unites__votre_visibilite_et_le_statut_de_votre_profil_:
    "Gerez vos unites votre visibilite et le statut de votre profil",
  vous_restez_connecte_mais_vos_annonces_ne_sont_plus_actives_dans_les_suggestions_:
    "Vous restez connecte mais vos annonces ne sont plus actives dans les suggestions",
  votre_profil_et_vos_logements_ne_remontent_plus_dans_la_carte_et_les_pages_de_destinations_:
    "Votre profil et vos logements ne remontent plus dans la carte et les pages de destinations",
  base_de_donnees_non_migree__vos_preferences_sont_sauvegardees_localement_pour_l_instant_:
    "Base de données non migrée vos preferences sont sauvegardees localement pour l'instant",
  delai_depasse: "Delai depasse",
  echeance_aujourd__hui: "Echeance aujourd hui",
  mois_restants: "Mois restants",
  nuits_dues_et_aucun_accueil_effectue: "Nuits dues et aucun accueil effectue",
  suivi_des_echanges: "Suivi des echanges",
  suivez_les_nuits_dues_dans_les_deux_sens__qui_vous_doit_des_nuits__qui_vous_devez_accueillir__et_le_temps_restant_pour_cl__turer_chaque_echange_:
    "Suivez les nuits dues dans les deux sens qui vous doit des nuits qui vous devez accueillir et le temps restant pour clôturer chaque echange",
  nom__logement__contrat__dates__statut_des_deux_c_tes_et_temps_restant_:
    "Nom logement contrat dates statut des deux côtés et temps restant",
  visualisez_vos_villes_cibles_et_les_rayons_de_recherche_autour_de_chaque_point_:
    "Visualisez vos villes cibles et les rayons de recherche autour de chaque point",
  __d_couvrir___: "d couvrir",
  les_incontournables___visiter_lors_de_votre_s_jour:
    "Les incontournables visiter lors de votre s'jour",
  impossible_de_finaliser_la_demande__r_essaie_dans_:
    "Impossible de finaliser la demande r essaie dans",
  r_server_ton_s_jour___: "réserver ton s'jour",
  parcours_simple_en_3__tapes__recherche__d_tails__v:
    "Parcours simple en 3 tapes recherche d'tails v",
  recherche: "Recherche",
  validation: "Validation",
  demande_envoy_e: "Demande envoy e",
  un_h_te_va_te_r_pondre_rapidement_avec_les_d_tails:
    "Un hôte va te r pondre rapidement avec les d'tails",
  cr_er_une_nouvelle_demande: "créer une nouvelle demande",
  "1__ton_s_jour": "1 ton s'jour",
  arriv_e: "Arrivée",
  pers_: "Pers",
  dates_flexibles: "Dates flexibles",
  dates_exactes: "Dates exactes",
  _3_jours: "3 jours",
  _7_jours: "7 jours",
  _14_jours: "14 jours",
  je_voyage_avec_des_animaux: "Je voyage avec des animaux",
  "2__infos_r_servation": "2 infos r servation",
  nom_complet: "Nom complet",
  ex__clara_martin: "Ex clara martin",
  message___l_h_te: "Message l'hôte",
  pr_sentation_rapide__heure_d_arriv_e__besoins_part:
    "Pr sentation rapide heure d'arrivée besoins part",
  "3__validation_de_la_r_servation": "3 validation de la r servation",
  destination: "Destination",
  s_jour: "séjour",
  flexibilit_: "Flexibilit",
  tarification_traveltrok: "Tarification traveltrok",
  frais_plateforme: "Frais plateforme",
  "1eur_voyageur___1eur_h_te": "1eur voyageur 1eur hôte",
  incluse: "Incluse",
  total_estim_: "Total estim",
  continuer: "Continuer",
  envoi___: "Envoi",
  confirmer_ma_r_servation: "Confirmer ma r servation",
  r_sum__intelligent: "R sum intelligent",
  prix_base: "Prix base",
  total_actuel: "Total actuel",
  inclut_1eur_voyageur___1eur_h_te_par_nuit__assuran:
    "Inclut 1eur voyageur 1eur hôte par nuit assuran",
  membres_actifs: "Membres actifs",
  note_moyenne: "Note moyenne",
  d_couvrez_: "découvrez",
  points_forts: "Points forts",
  conseils_pratiques: "Conseils pratiques",
  informations_pratiques: "Informations pratiques",
  meilleure_saison: "Meilleure saison",
  s_jour_moyen: "séjour moyen",
  langue: "Langue",
  monnaie: "Monnaie",
  fuseau_horaire: "Fuseau horaire",
  voir_les_logements: "Voir les logements",
  nous_contacter: "Nous contacter",
  villa: "Villa",
  logements_disponibles___: "Logements disponibles",
  annonces___la_nuit_avec_h_tes_v_rifi_s_:
    "Annonces la nuit avec hôtes vérifié s",
  voir_la_carte_des_logements: "Voir la carte des logements",
  h_te_v_rifi_: "hôte vérifié",
  mod_le_traveltrok: "Mod le traveltrok",
  r_server: "réserver",
  pas_encore_de_logements_ici: "Pas encore de logements ici",
  sois_le_premier_h_te___proposer_son_logement___:
    "Sois le premier hôte proposer son logement",
  ajouter_mon_logement: "Ajouter mon logement",
  destinations_proches: "Destinations proches",
  explorez_d_autres_destinations_en_: "Explorez d'autres destinations en",
  am_rique_du_nord: "Am rique du nord",
  am_rique_du_sud: "Am rique du sud",
  oc_anie: "Oc anie",
  afrique: "Afrique",
  asie: "Asie",
  europe: "Europe",
  carte_des_destinations: "Carte des destinations",
  destinations_affich_es: "Destinations affich es",
  continents: "Continents",
  survolez_un_point_pour_voir_les_d_tails:
    "Survolez un point pour voir les d'tails",
  _changes_r_alis_s: "changes réalisés",
  mes_favoris: "Mes favoris",
  sauvegard_: "Sauvegard",
  tout_effacer: "Tout effacer",
  s_lectionn_: "S lectionn",
  pour_comparaison: "Pour comparaison",
  voir_la_comparaison: "Voir la comparaison",
  trier_par__: "Trier par",
  note: "Note",
  _changes: "changes",
  capacit_: "Capacit",
  pi_ces: "Pi ces",
  type_de_logement: "Type de logement",
  effacer: "Effacer",
  r_initialiser_les_filtres: "R initialiser les filtres",
  filtres_actifs__: "Filtres actifs",
  aucun_r_sultat: "Aucun r sultat",
  aucun_favori_ne_correspond___vos_filtres_:
    "Aucun favori ne correspond vos filtres",
  comparaison_des_logements: "Comparaison des logements",
  logements_s_lectionn_s: "Logements s'lectionn s",
  fermer: "Fermer",
  astuce: "Astuce",
  utilisez_les_filtres_pour_affiner_vos_favoris_par:
    "Utilisez les filtres pour affiner vos favoris par",
  type: "Type",
  s_lectionnez_ensuite_jusqu______4_logements_pour_l:
    "S lectionnez ensuite jusqu  4 logements pour l",
  aucun_sch_ma_conversation_compatible_trouv__:
    "Aucun sch ma conversation compatible trouv",
  souhaite_venir_dynamique: "Souhaite venir dynamique",
  aimerais_visiter_dynamique: "Aimerais visiter dynamique",
  demande_ignor_e_: "Demande ignor e",
  conversation_introuvable_: "Conversation introuvable",
  impossible_d_ouvrir_la_discussion_pour_le_moment_:
    "Impossible d'ouvrir la discussion pour le moment",
  demande_supprim_e_: "Demande supprim e",
  bonjour_merci_dynamique: "Bonjour merci dynamique",
  demande_supprim_e_avec_un_message_poli_:
    "Demande supprimé avec un message poli",
  impossible_de_supprimer_cette_demande_pour_le_mome:
    "Impossible de supprimer cette demande pour le mome",
  demandes_directes: "Demandes directes",
  matching_auto: "Ils veulent venir dans ton secteur",
  match_r_ciproque: "Match réciproque",
  carte_secteur: "Carte secteur",
  toutes: "Toutes",
  lik_es: "Likées",
  en_discussion: "En discussion",
  ignor_es: "Ignorées",
  sans_date_pr_cise__juste__change_: "Sans date précise juste échange",
  date_pr_cise___dans_les_6_mois: "Date précise dans les 6 mois",
  date_pr_cise___dans_l_ann_e: "Date précise dans l'ann e",
  flexible: "Flexible",
  date_pr_cise: "Date précise",
  dates_identiques: "Dates identiques",
  dates_compatibles: "Dates compatibles",
  dates_diff_rentes: "Dates diff rentes",
  dates_inconnues: "Dates inconnues",
  souhaite_venir__: "Souhaite venir",
  voir_le_logement_cibl_: "Voir le logement cibl",
  personnes_int_ress_es_par_votre_secteur:
    "Personnes int ress es par votre secteur",
  vert___match_r_ciproque_ville___dates: "Vert match réciproque ville dates",
  int_r_t_entrant: "Int r t entrant",
  logement_cibl___: "Logement cibl",
  dates__: "Dates",
  sans_date_pr_cise: "Sans date précise",
  ouvrir_le_chat: "Ouvrir le chat",
  pas_encore_de_points_sur_la_carte: "Pas encore de points sur la carte",
  les_membres_qui_veulent_venir_dans_votre_secteur_a:
    "Les membres qui veulent venir dans votre secteur à",
  logement_vis_: "Logement visé",
  demande: "Demande",
  message: "Message",
  logement_s_: "logement(s)",
  annonce_indisponible: "Annonce indisponible",
  jour_s_: "jour(s)",
  dur_e___d_finir: "Duré d'finir",
  match_auto: "Match auto",
  r_ciproque: "Réciproque",
  discuter_dans_la_messagerie: "Discuter dans la messagerie",
  ignorer_la_demande: "Ignorer la demande",
  ignorer: "Ignorer",
  supprimer_avec_message_poli: "Supprimer avec message poli",
  poli: "Poli",
  supprimer_sans_message: "Supprimer sans message",
  suppr_: "Suppr",
  aucune_demande_pour_le_moment: "Aucune demande pour le moment",
  le_tableau_est_pr_t__les_demandes_s_afficheront_ic:
    "Le tableau est pr t les demandes s'afficheront ic",
  surface: "Surface",
  voyagez: "Voyagez",
  envie_d___changer_avec_: "Envie d' changer avec",
  proposez_un__change_de_logement_et_d_couvrez_:
    "Proposez un échange de logement et d'couvrez",
  gratuitement_: "Gratuitement",
  voir_la_fiche_du_logement: "Voir la fiche du logement",
  carte_des_logements: "Carte des logements",
  r_sultats_visibles: "résultats visibles",
  jour: "Jour",
  s_lectionn_s: "sélectionné s",
  printemps: "Printemps",
  _t_: "t",
  automne: "Automne",
  hiver: "Hiver",
  toute_l__ann_e: "Toute l'ann e",
  bonjour_host_dynamic: "Bonjour host dynamic",
  impossible_de_contacter_cet_h_te____errormessage__:
    "Impossible de contacter cet hôte errormessage",
  impossible_de_contacter_cet_h_te_pour_le_moment_:
    "Impossible de contacter cet hôte pour le moment",
  annonce_introuvable_: "Annonce introuvable",
  choisissez_vos_dates_pour_envoyer_la_proposition_:
    "Choisissez vos dates pour envoyer la proposition",
  la_date_de_d_part_doit__tre_post_rieure___la_date_:
    "La date de départ doit être postérieure à la date d'arrivée",
  proposition_d__change_avec_dates_pr_cises:
    "Proposition d'échange avec dates précises",
  __logement_cibl_: "Logement ciblé",
  __ville: "Ville",
  __arriv_e_souhait_e: "Arrivée souhaitée",
  __d_part_souhait_: "Départ souhaité",
  __dur_e: "Durée",
  nuit_s_: "Nuit(s)",
  __voyageurs: "Voyageurs",
  je_suis_ouvert_e____une_n_gociation_si_besoin_:
    "Je suis ouvert(e) à une négociation si besoin.",
  indiquez_un_nombre_de_nuits_valide_pour_la_proposi:
    "Indiquez un nombre de nuits valide pour la proposition",
  proposition_d__change_flexible__sans_dates_fix_es_:
    "Proposition d'échange flexible sans dates fixées",
  __je_propose: "Je propose",
  __je_demande: "Je demande",
  on_valide_les_dates_ensemble_ensuite_selon_nos_dis:
    "On valide les dates ensemble ensuite selon nos disponibilités.",
  indiquez_un_nombre_de_nuits_valide_: "Indiquez un nombre de nuits valide",
  proposition_d__change__n_importe_quand_dans_l_ann_:
    "Proposition d'échange n'importe quand dans l'année",
  __dur_e_souhait_e: "Durée souhaitée",
  __p_riode_pr_f_r_e: "Période préférée",
  je_suis_flexible_sur_les_dates_exactes_et_pr_t_e__:
    "Je suis flexible sur les dates exactes et prêt(e) à en parler.",
  proposition_invalide_: "Proposition invalide",
  proposition_envoy_e__ouverture_de_la_discussion___:
    "Proposition envoyée, ouverture de la discussion...",
  impossible_d_envoyer_votre_proposition____errormes:
    "Impossible d'envoyer votre proposition",
  impossible_d_envoyer_votre_proposition_pour_le_mom:
    "Impossible d'envoyer votre proposition pour le moment",
  logement_introuvable: "Logement introuvable",
  retour_aux_logements: "Retour aux logements",
  annonce_airbnb: "Annonce airbnb",
  lien_airbnb_verification_helper:
    "Ce lien nous permet de vérifier que vous êtes bien le gestionnaire de l'annonce.",
  aucune_photo_disponible: "Aucune photo disponible",
  logement_propos__par: "Logement proposé par",
  __propos_de_ce_logement: "À propos de ce logement",
  aucune_description_fournie_: "Aucune description fournie",
  ce_que_propose_ce_logement: "Ce que propose ce logement",
  description_du_logement: "Description du logement",
  aucun__quipement_sp_cifi__: "Aucun équipeent sp cifi",
  _change_entre_h_tes: "échange entre hôtes",
  votre_proposition_d__change: "Votre proposition d'change",
  quand_vous_voulez: "Quand vous voulez",
  je_propose: "Je propose",
  nuits_chez_moi: "Nuits chez moi",
  je_demande: "Je demande",
  nuits_chez_vous: "Nuits chez vous",
  nombre_de_nuits: "Nombre de nuits",
  p_riode_pr_f_r_e: "P riode pr f r e",
  message__optionnel_: "Message optionnel",
  ex__nous_sommes_flexibles__on_peut_s_adapter___vos:
    "Ex nous sommes flexibles on peut s'adapter vos",
  entrer_en_n_gociation: "Entrer en négociation",
  envoyer_ma_proposition: "Envoyer ma proposition",
  vous_pouvez_proposer_un__change_avec_ou_sans_dates:
    "Vous pouvez proposer un échange avec ou sans dates",
  informations_l_gales: "Informations l'gales",
  conditions_d____utilisation: "Conditions d' utilisation",
  en_utilisant_traveltrok__vous_acceptez_d_utilise:
    "En utilisant traveltrok vous acceptez d'utilise",
  les__changes_se_font_directement_entre_membres__:
    "Les changes se font directement entre membres",
  traveltrok_peut_suspendre_un_compte_en_cas_de_co:
    "DONKEY TRAVEL peut suspendre un compte en cas de co",
  en_rejoignant_traveltrok__vous_acceptez_ces_engagements__la_confiance_se_construit_sur_des_actes_simples__honn_tet___respect_et_parole_tenue_:
    "En rejoignant DONKEY TRAVEL, vous acceptez ces engagements. La confiance se construit sur des actes simples.",
  cette_charte_est_align_e_avec_les_standards_publics_des_plateformes_majeures__respect_du_logement__fiabilit___anti_f_te__communication__:
    "Une charte solide en adéquation avec les meilleures pratiques d'autres entreprises célèbres.",
  retrait_du_club_en_cas_de_manquement_grave_ou_r_p_tition_:
    "Retrait du club suite à répétition ou faute grave.",
  exclusion_d_finitive: "Exclusion définitive",
  compte_limit__le_temps_de_v_rifier_les_faits_et_prot_ger_la_communaut__:
    "Compte restreint en attente des faits.",
  suspension_temporaire: "Suspension temporaire",
  rappel__crit_des_r_gles__avec_demande_de_correction_imm_diate_:
    "Rappel des règles et correction requise.",
  avertissement_officiel: "Avertissement officiel",
  le_club_prot_ge_les_h_tes_fiables__les_manquements_r_p_t_s_ou_graves_entra_nent_des_mesures_imm_diates_:
    "Le club protège les hôtes fiables. Les manquements graves entraînent des mesures.",
  toute_annulation_doit__tre_document_e_dans_la_messagerie_et_trait_e_par_le_support_:
    "Toute annulation doit être documentée dans la messagerie et traitée par le support.",
  on_n_annule_pas_un__change_sans_raison_valable__en_cas_de_force_majeure__sinistre__maladie_grave__impossibilit__l_gale___un_report_doit__tre_propos__au_plus_vite_:
    "On n'annule pas un échange sans raison valable. En cas de force majeure (sinistre, maladie grave, impossibilité légale), un report doit être proposé au plus vite.",
  je_communique_vite_en_cas_de_doute_ou_de_changement_:
    "Je communique vite en cas de doute ou de changement.",
  j_accueille_quelqu_un_qui_exerce_le_m_me_m_tier_d_h_te_:
    "J'accueille quelqu'un qui exerce le même métier d'hôte.",
  j_assure_un_accueil_chaleureux_et_professionnel_:
    "J'assure un accueil chaleureux et professionnel.",
  relation_entre_h_tes: "Relation entre hôtes",
  les__ventuels_frais_de_m_nage_sont_annonc_s_et_valid_s_avant_s_jour_:
    "Les éventuels frais de ménage sont annoncés et validés avant l'échange.",
  les_informations_d_acc_s_et_de_fonctionnement_sont_claires_:
    "Les informations d'accès et de fonctionnement sont claires.",
  linge_et_pr_paration: "Linge et préparation",
  le_niveau_de_prestation_reste_identique__m_me_en__change_gratuit_:
    "Le niveau de prestation reste identique, même en échange gratuit.",
  le_logement_est_propre_et_pr_t___vivre_d_s_l_arriv_e_:
    "Le logement est propre et prêt à vivre dès l'arrivée.",
  je_pr_pare_le_logement_comme_pour_un_client_airbnb_:
    "Je prépare le logement comme pour un client Airbnb.",
  qualit__d_accueil__quivalente: "Qualité d'accueil équivalente",
  je_respecte_le_calme__les_voisins_et_le_quartier_:
    "Je respecte le calme, les voisins et le quartier.",
  aucune_f_te___v_nement_ou_invitation_non_autoris_e_dans_le_logement_:
    "Aucune fête, événement ou invitation non autorisée dans le logement.",
  je_respecte_le_r_glement_int_rieur_de_l_h_te_:
    "Je respecte le règlement intérieur de l'hôte.",
  vie_de_quartier_et_r_gles: "Vie de quartier et règles",
  quand_des_dates_sont_bloqu_es__je_m_engage___venir_:
    "Quand des dates sont bloquées, je m'engage à venir.",
  je_ne_mens_pas_sur_la_valeur_prix_habituel_de_mon_logement_:
    "Je ne mens pas sur la valeur prix habituel de mon logement.",
  je_ne_mens_pas_sur_ma_fiche__mon_historique_ni_mon_logement_:
    "Je ne mens pas sur ma fiche, mon historique ni mon logement.",
  honn_tet__et_fiabilit_: "Honnêteté et fiabilité",
  je_respecte_le_mat_riel__les__quipements_et_les_consignes_de_d_part_:
    "Je respecte le matériel, les équipements et les consignes de départ.",
  je_range_le_linge_utilis___ex__draps_en_boule___l_endroit_indiqu___pour_limiter_les_frais_de_m_nage_:
    "Je range le linge utilisé (ex: draps en boule) à l'endroit indiqué, pour limiter les frais de ménage.",
  je_rends_le_logement_aussi_propre_que_je_l_ai_trouv_:
    "Je rends le logement aussi propre que je l'ai trouvé.",
  respect_total_du_logement: "Respect total du logement",
  traveltrok_est_un_club_d_h_tes_s_rieux__une_bonne_note_implique_une_conduite_exemplaire__en_tant_que_voyageur_comme_en_tant_qu_h_te_:
    "DONKEY TRAVEL est un club d'hôtes sérieux ; une bonne note implique une conduite exemplaire, en tant que voyageur comme en tant qu'hôte.",
  "howItWorks.cta.explore": "Explorer les destinations",
  "howItWorks.cta.signup": "Voir nos offres",
  "howItWorks.cta.subtitle":
    "Commencez par louer votre propre logement. Puis activez le échange si vous souhaitez échanger entre hôtes.",
  "howItWorks.cta.title": "Prêt à lancer vos locations ?",
  publiez_votre_logement__validez_votre_profil_et_commencez_a_recevoir_des_propositions_d_echange_:
    "Publiez votre logement, validez votre profil et commencez à recevoir des propositions d'échange.",
  visualisez_la_densite_des_logements_deja_inscrits_dans_le_club__les_points_restent_anonymes__pas_d_adresse__pas_de_detail__juste_la_dynamique_du_reseau_:
    "Visualisez la densité des logements déjà inscrits dans le club. Les points restent anonymes (pas d'adresse, pas de détail, juste la dynamique du réseau).",
  prenez_du_recul_pour__viter_l__puisement_li___l_accueil_continu_:
    "Prenez du recul pour éviter l'épuisement lié à l'accueil continu.",
  _an: "/ an",
  traveltrok_connecte_les_h_tes_du_monde_entier_pour_des_s_jours_authentiques_et_abordables_:
    "DONKEY TRAVEL connecte les hôtes du monde entier pour des séjours authentiques et abordables.",
  ____100__made_in_france__picardie_: "🇫🇷 100% Made in France (Picardie)",
  pas_la_silicon_valley__mais_la_vall_e_de_la_haute_somme_:
    "Pas la Silicon Valley, mais la vallée de la Haute-Somme.",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_not_s_4_5___offre_lancement_2026___50__:
    "Échanges dans toute l’Europe entre hôtes Airbnb notés 4,5+. Offre lancement 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes_creuses_en_vraies_respirations_sans_exploser_votre_budget_:
    "Après des mois d'accueil, transformez vos périodes creuses en vraies respirations sans exploser votre budget.",
  prenez_du_recul_pour__viter_l__puisement_li____l_accueil_continu_:
    "Prenez du recul pour éviter l'épuisement lié à l'accueil continu.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exigences_du_terrain__puis_partagez_vos_m_thodes_et_vos_retours_d_exp_rience_:
    "Accueillez des hôtes qui connaissent déjà les exigences du terrain, puis partagez vos méthodes et vos retours d'expérience.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_membres_du_club_:
    "Voyagez à coût réduit grâce aux échanges entre membres du club.",
  quand_votre_quota_local_est_atteint__vous_pouvez__changer_hors_plateforme_sous_r_serve_de_conformit__locale_:
    "Quand votre quota local est atteint, vous pouvez échanger hors plateforme sous réserve de conformité locale.",
  traveltrok_est_une_r_volution_europ_enne__une_plateforme_d__changes_pour_les_h_tes_qui_paient_d_j__chauffage__taxes__imp_ts___lectricit___internet_et_entretien__et_accueillent_toute_l_ann_e_comme___l_h_tel__ici__vous__changez_avec_des_h_tes_qui_savent_accueillir__vous_partagez_vos_exp_riences__puis_vous_partez_d_couvrir_un_autre_endroit_sans_vous_ruiner_:
    "DONKEY TRAVEL est une révolution européenne: une plateforme d'échanges pour les hôtes qui paient déjà chauffage, taxes, impôts, électricité, internet et entretien, et accueillent toute l'année comme à l'hôtel. Ici, vous échangez avec des hôtes qui savent accueillir, vous partagez vos expériences, puis vous partez découvrir un autre endroit sans vous ruiner.",
  ___notre_mod_le_repose_uniquement_sur_les_abonnements__pas_sur_l_exploitation_des_donn_es_:
    "👉 Notre modèle repose uniquement sur les abonnements, pas sur l’exploitation des données.",
  ___sans_publicit___sans_revente_de_donn_es__100___financ__par_les_membres_:
    "🔒 Sans publicité. Sans revente de données. 100 % financé par les membres.",
  le_club_n_est_pas_un_conseil_juridique___chaque_membre_doit_respecter_les_r_gles_locales__d_clarations__quotas__copropri_t___fiscalit___etc___:
    "Le club n'est pas un conseil juridique ; chaque membre doit respecter les règles locales (déclarations, quotas, copropriété, fiscalité, etc.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_h_tes_airbnb:
    "Une plateforme d'échanges européenne réservée aux hôtes Airbnb",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_unique_pour__changer_dans_toute_l_europe_:
    "Club privé pour hôtes notés 4,5+ : un abonnement unique pour échanger dans toute l’Europe.",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_ou__gale___4_5_:
    "Réservé aux hôtes Airbnb avec une note supérieure ou égale à 4,5.",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eur_an__prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Réduction de 50% en 2026: 25EUR/an au lieu de 50EUR/an. Prix garanti à vie pour les 1000 premiers inscrits.",
  basse_saison__pause__rencontres_entre_h_tes___conomies_vacances__tout_est_pens__pour_les_h_tes_actifs_en_europe_:
    "Basse saison, pause, rencontres entre hôtes, économies vacances: tout est pensé pour les hôtes actifs en Europe.",
  accueillez_des_membres_et_faites_vous_accueillir_en_retour__un__change_simple__direct_et_sans_argent_entre_propri_taires_:
    "Accueillez des membres et faites-vous accueillir en retour. Un échange simple, direct et sans argent entre propriétaires.",
  _nous_avons__chang__notre_maison___lyon_contre_une_villa_en_corse__co_t___0___:
    '"Nous avons échangé notre maison à Lyon contre une villa en Corse. Coût : 0€."',
  pas_de_monnaie__pas_de_points__juste_un_accord_entre_deux_propri_taires__je_viens_chez_toi__tu_viens_chez_moi_:
    "Pas de monnaie, pas de points. Juste un accord entre deux propriétaires. Je viens chez toi, tu viens chez moi.",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous_mettez_d_accord_pour__changer_vos_logements_:
    "Vous trouvez un membre qui vous plaît et vous vous mettez d'accord pour échanger vos logements.",
  pas_de_points___compter__juste_le_plaisir_de_partager_et_de_se_rencontrer_:
    "Pas de points à compter. Juste le plaisir de partager et de se rencontrer.",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_voyager_:
    "Plus qu'une économie, c'est une nouvelle façon de voyager.",
  les__changes_sont_totalement_gratuits__pas_de_frais_de_service__pas_de_frais_de_m_nage__sauf_accord_sp_cifique__:
    "Les échanges sont totalement gratuits. Pas de frais de service, pas de frais de ménage (sauf accord spécifique).",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_accueillez_quelqu_un_qui_conna_t_la_valeur_d_un_logement_:
    "Seuls les hôtes vérifiés peuvent échanger. Vous accueillez quelqu'un qui connaît la valeur d'un logement.",
  oubliez_la_valeur_des_points__une_nuit_est_une_nuit__l__change_est_bas__sur_la_confiance_entre_h_tes_:
    "Oubliez la valeur des points. Une nuit est une nuit. L'échange est basé sur la confiance entre hôtes.",
  __an: "/ an",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_no:
    "Échanges dans toute l’Europe entre hôtes Airbnb notés 4,5+. Offre lancement 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes:
    "Après des mois d'accueil, transformez vos périodes creuses en vraies respirations sans exploser votre budget.",
  prenez_du_recul_pour__viter_l__puisement_li____l_a:
    "Prenez du recul pour éviter l'épuisement lié à l'accueil continu.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exig:
    "Accueillez des hôtes qui connaissent déjà les exigences du terrain, puis partagez vos méthodes et vos retours d'expérience.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_mem:
    "Voyagez à coût réduit grâce aux échanges entre membres du club.",
  quand_votre_quota_local_est_atteint__vous_pouvez__:
    "Quand votre quota local est atteint, vous pouvez échanger hors plateforme sous réserve de conformité locale.",
  la_r_volution_des_h_tes_en_europe: "La révolution des hôtes en Europe",
  enfin_une_pause_pour_les_h_tes_airbnb_not_s_4_5_:
    "Enfin une pause pour les hôtes Airbnb notés 4,5+",
  traveltrok_est_une_r_volution_europ_enne__une_plat:
    "DONKEY TRAVEL est une révolution européenne: une plateforme d'échanges pour les hôtes qui paient déjà chauffage, taxes, impôts, électricité, internet et entretien, et accueillent toute l'année comme à l'hôtel. Ici, vous échangez avec des hôtes qui savent accueillir, vous partagez vos expériences, puis vous partez découvrir un autre endroit sans vous ruiner.",
  prix_garanti___vie_pour_les_1000_premiers_inscrits:
    "Prix garanti à vie pour les 1000 premiers inscrits.",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produi:
    "Chez DONKEY TRAVEL, vos données ne sont pas un produit.",
  nous_ne_vendons_jamais_les_informations_de_nos_mem:
    "Nous ne vendons jamais les informations de nos membres.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___:
    "Nous ne partageons aucune donnée avec des tiers à des fins commerciales.",
  le_site_est_s_curis__et_vos__changes_restent_priv_:
    "Le site est sécurisé et vos échanges restent privés.",
  traveltrok_est_garanti_sans_publicit____vous__tes_:
    "DONKEY TRAVEL est garanti sans publicité : vous êtes le membre, pas le produit.",
  ___notre_mod_le_repose_uniquement_sur_les_abonneme:
    "👉 Notre modèle repose uniquement sur les abonnements, pas sur l’exploitation des données.",
  ___sans_publicit___sans_revente_de_donn_es__100___:
    "🔒 Sans publicité. Sans revente de données. 100 % financé par les membres.",
  le_club_n_est_pas_un_conseil_juridique___chaque_me:
    "Le club n'est pas un conseil juridique ; chaque membre doit respecter les règles locales (déclarations, quotas, copropriété, fiscalité, etc.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_:
    "Une plateforme d'échanges européenne réservée aux hôtes Airbnb",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u:
    "Club privé pour hôtes notés 4,5+ : un abonnement unique pour échanger dans toute l’Europe.",
  acc_s_r_serv_: "Accès réservé",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_:
    "Réservé aux hôtes Airbnb avec une note supérieure ou égale à 4,5.",
  europe_unique: "Europe unique",
  "50eur_an_pour__changer_dans_toute_l_europe_":
    "50EUR/an pour échanger dans toute l’Europe.",
  lancement_2026: "Lancement 2026",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu:
    "Réduction de 50% en 2026: 25EUR/an au lieu de 50EUR/an. Prix garanti à vie pour les 1000 premiers inscrits.",
  club_d__change_h_tes_airbnb: "Club d'échange hôtes Airbnb",
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes:
    "Optimisez vos périodes creuses grâce aux échanges",
  basse_saison__pause__rencontres_entre_h_tes___cono:
    "Basse saison, pause, rencontres entre hôtes, économies vacances: tout est pensé pour les hôtes actifs en Europe.",
  r_serv__aux_h_tes_traveltrok: "Réservé aux hôtes DONKEY TRAVEL",
  voyagez_gratuitement_gr_ce___votre_logement:
    "Voyagez gratuitement grâce à votre logement",
  accueillez_des_membres_et_faites_vous_accueillir_e:
    "Accueillez des membres et faites-vous accueillir en retour. Un échange simple, direct et sans argent entre propriétaires.",
  devenir_h_te: "Devenir hôte",
  comment__a_marche__: "Comment ça marche ?",
  _nous_avons__chang__notre_maison___lyon_contre_une:
    '"Nous avons échangé notre maison à Lyon contre une villa en Corse. Coût : 0€."',
  amis_partageant_un_repas_en_corse: "Amis partageant un repas en Corse",
  sophie___marc__membres_depuis_2023: "Sophie & Marc, membres depuis 2023",
  pas_besoin_d__changer_aux_m_mes_dates____tu_viens:
    "Pas besoin d'échanger aux mêmes dates : tu viens chez moi en juin, je viens chez toi en septembre !",
  l__change_direct___simple_et_humain: "L'échange direct : simple et humain",
  pas_de_monnaie__pas_de_points__juste_un_accord_ent:
    "Pas de monnaie, pas de points. Juste un accord entre deux propriétaires. Je viens chez toi, tu viens chez moi.",
  "1__accord_mutuel": "1. Accord mutuel",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous:
    "Vous trouvez un membre qui vous plaît et vous vous mettez d'accord pour échanger vos logements.",
  "2__flexibilit__totale": "2. Flexibilité totale",
  "3__z_ro_comptabilit_": "3. Zéro comptabilité",
  pas_de_points___compter__juste_le_plaisir_de_parta:
    "Pas de points à compter. Juste le plaisir de partager et de se rencontrer.",
  pourquoi_les_h_tes_adorent_ce_syst_me__:
    "Pourquoi les hôtes adorent ce système ?",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_:
    "Plus qu'une économie, c'est une nouvelle façon de voyager.",
  "0__de_frais": "0€ de frais",
  les__changes_sont_totalement_gratuits__pas_de_frai:
    "Les échanges sont totalement gratuits. Pas de frais de service, pas de frais de ménage (sauf accord spécifique).",
  confiance_totale: "Confiance totale",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac:
    "Seuls les hôtes vérifiés peuvent échanger. Vous accueillez quelqu'un qui connaît la valeur d'un logement.",
  simplicit_: "Simplicité",
  oubliez_la_valeur_des_points__une_nuit_est_une_nui:
    "Oubliez la valeur des points. Une nuit est une nuit. L'échange est basé sur la confiance entre hôtes.",
  rejoignez_la_communaut__des_h_tes: "Rejoignez la communauté des hôtes",
  rejoignez_la_communaut__et_commencez____changer_:
    "Rejoignez la communauté et commencez à échanger.",
  commencer_maintenant: "Commencer maintenant",
  chargement___: "Chargement...",
  accueil: "Accueil",
  comment_a_marche: "Comment ça marche",
  vos_engagements: "Vos engagements",
  pays: "Pays",
  logements: "Logements",
  _change_h_te: "Échange Hôte",
  devenir_membre: "Devenir membre",
  se_d_connecter: "Se déconnecter",
  mon_espace: "Mon espace",
  connexion: "Connexion",
  connect_: "Connecté",
  visuel_en_cours_de_g_n_ration_ai___: "Visuel en cours de génération AI...",
  tableau_de_bord: "Tableau de bord",
  mes_annonces: "Mes annonces",
  o__je_veux_aller: "Où je veux aller",
  qui_veut_venir_chez_moi: "Matching intelligent",
  destinations: "Destinations",
  carte_des_membres: "Carte des membres",
  calendrier: "Calendrier",
  votre_coffre: "Votre coffre",
  favoris: "Favoris",
  messages: "Messages",
  mon_profil: "Mon profil",
  pr_f_rences: "Préférences",
  profil: "Profil",
  h_te: "Hôte",
  membre_fondateur: "Membre Fondateur",
  membre: "Membre",
  r_duire__tendre: "Réduire/étendre",
  r_duire_le_menu: "Réduire le menu",
  cette_page_n_a_pas__t__g_n_r_e: "Cette page n'a pas été générée",
  donne_moi_plus_de_d_tails_sur_cette_page_pour_que_je_puisse_la_g_n_rer:
    "Donne-moi plus de détails sur cette page pour que je puisse la générer",
  connexion_en_cours___: "Connexion en cours...",
  email_ou_mot_de_passe_incorrect: "Email ou mot de passe incorrect",
  une_erreur_est_survenue: "Une erreur est survenue",
  erreur_de_connexion_google: "Erreur de connexion Google",
  connecte_toi_pour_retrouver_ta_communaut_:
    "Connecte-toi pour retrouver ta communauté",
  rejoins_la_communaut__des_h_tes_traveltrok:
    "Rejoins la communauté des hôtes DONKEY TRAVEL",
  inscription: "Inscription",
  continuer_avec_google: "Continuer avec Google",
  ou: "ou",
  ton_pr_nom_et_nom: "Ton prénom et nom",
  jean_h_mar: "Jean Hémar",
  lien_annonce_airbnb: "Lien de votre annonce Airbnb",
  veuillez_saisir_un_lien_airbnb_valide:
    "Veuillez renseigner un lien Airbnb valide",
  lien_calendrier_ical:
    "Lien iCal de votre calendrier Airbnb (Optionnel pour l'instant)",
  lien_ical_explication_lecture_seule:
    "Donkey Travel ne modifie jamais votre calendrier Airbnb. Nous nous contentons de le lire pour afficher vos disponibilités. Vous devrez continuer à bloquer manuellement vos dates d'échange sur Airbnb pour éviter les doubles réservations.",
  note_airbnb: "Note Airbnb",
  abonnement: "Abonnement",
  europe_unique___50eur_an: "Europe unique - 50EUR/an",
  offre_lancement_2026__25eur_an___50__:
    "Offre lancement 2026: 25EUR/an (-50%)",
  prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Prix garanti à vie pour les 1000 premiers inscrits.",
  mot_de_passe: "Mot de passe",
  "8_caract_res_minimum": "8 caractères minimum",
  connexion___: "Connexion...",
  cr_ation_du_compte___: "Création du compte...",
  se_connecter: "Se connecter",
  cr_er_mon_compte: "Créer mon compte",
  mot_de_passe_oubli___: "Mot de passe oublié ?",
  en_cr_ant_un_compte__tu_acceptes_nos_:
    "En créant un compte, tu acceptes nos ",
  cgu: "CGU",
  _et_notre_: " et notre ",
  politique_de_confidentialit_: "politique de confidentialité",
  r_servation_de_logements: "Réservation de logements",
  support_h_te_prioritaire: "Support hôte prioritaire",
  carte___filtres_avanc_s: "Carte + filtres avancés",
  flux_de_r_servation__tape_par__tape: "Flux de réservation étape par étape",
  couverture_dommages_assistance: "Couverture dommages/assistance",
  multi_logements___reporting: "Multi-logements + reporting",
  comparatif_des_modes: "Comparatif des modes",
  ce_que_tu_actives_selon_ton_usage_traveltrok_:
    "Ce que tu actives selon ton usage TRAVELTROK.",
  fonction: "Fonction",
  voyageur: "Voyageur",
  pro: "Pro",
  abonnement_europe_unique: "Abonnement Europe unique",
  rejoindre_le_club_europe: "Rejoindre le club Europe",
  basse_saison: "Basse saison",
  pause: "Faites une pause",
  rencontres: "Rencontrez des hôtes",
  _conomies: "Économies",
  quota_atteint: "Quota atteint",
  _ligibilit_: "Éligibilité",
  zone_d__change: "Zone d'échange",
  toute_l_europe: "Toute l'Europe",
  mod_le: "Modèle",
  abonnement_unique_annuel: "Abonnement unique annuel",
  propri_taire_europ_en_en_pause: "Propriétaire européen en pause",
  v_rification: "Vérification",
  h_tes_certifi_s: "Hôtes Certifiés",
  abonnement_unique_traveltrok: "Abonnement unique DONKEY TRAVEL",
  offre_lancement_2026__25eur_an_au_lieu_de_50eur_an:
    "Offre lancement 2026: 25EUR/an au lieu de 50EUR/an",
  pourquoi_ce_club_fonctionne_pour_les_h_tes:
    "Pourquoi ce club fonctionne pour les hôtes",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produit_:
    "Chez DONKEY TRAVEL, vos données ne sont pas un produit.",
  nous_ne_vendons_jamais_les_informations_de_nos_membres_:
    "Nous ne vendons jamais les informations de nos membres.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___des_fins_commerciales_:
    "Nous ne partageons aucune donnée avec des tiers à des fins commerciales.",
  le_site_est_s_curis__et_vos__changes_restent_priv_s_:
    "Le site est sécurisé et vos échanges restent privés.",
  traveltrok_est_garanti_sans_publicit____vous__tes_le_membre__pas_le_produit_:
    "DONKEY TRAVEL est garanti sans publicité : vous êtes le membre, pas le produit.",
  rejoindre_le_club: "Rejoindre le club",
  trouver_un_h_te: "Trouver un hôte",
  proposer_un__change: "Proposer un échange",
  synchronisation_mise___jour_avec_succ_s:
    "Synchronisation mise à jour avec succès",
  erreur_lors_de_la_mise___jour: "Erreur lors de la mise à jour",
  indisponible: "Indisponible",
  r_serv_: "Réservé",
  erreur_chargement: "Erreur chargement",
  inconnue: "Inconnue",
  impossible_de_r_cup_rer_le_calendrier_ical__v_rifiez_l_url_ical_airbnb_et_r_essayez_:
    "Impossible de récupérer le calendrier iCal. Vérifiez l'URL iCal Airbnb et réessayez.",
  r_servation: "Réservation",
  _v_nements_synchronis_s: "événements synchronisés",
  _v_nements_import_s: "événements importés",
  erreur_sync: "Erreur sync",
  _chec_de_synchronisation: "Échec de synchronisation",
  dates_bloqu_es_avec_succ_s: "Dates bloquées avec succès",
  erreur_blocage: "Erreur blocage",
  mois: "Mois",
  aujourd_hui: "Aujourd'hui",
  d_tails: "Détails",
  actions: "Actions",
  bloquer: "Bloquer",
  filtres: "Filtres",
  confirm_: "Confirmé",
  en_attente: "En attente",
  proposition: "Proposition",
  bloqu_: "Bloqué",
  synchronisation: "Synchronisation",
  configurer: "Configurer",
  airbnb_connect_: "Airbnb connecté",
  derni_re_synchro_r_ussie: "Dernière synchro réussie",
  derni_re_synchro_en__chec: "Dernière synchro en échec",
  calendrier_connect___lancez_une_synchro_pour_importer_vos_r_servations_airbnb_:
    "Calendrier connecté. Lancez une synchro pour importer vos réservations Airbnb.",
  synchro___: "Synchro...",
  forcer_la_synchro: "Forcer la synchro",
  non_synchronis_: "Non synchronisé",
  connectez_votre_calendrier_airbnb_pour__viter_les_doubles_r_servations__:
    "Connectez votre calendrier Airbnb pour éviter les doubles réservations !",
  bloquer_des_dates: "Bloquer des dates",
  s_lection: "Sélection",
  jours: "jours",
  raison__optionnel__ex__travaux_: "Raison (optionnel, ex: Travaux)",
  annuler: "Annuler",
  confirmer: "Confirmer",
  synchronisation_airbnb: "Synchronisation Airbnb",
  ajoutez_vos_liens_airbnb_pour_synchroniser_automatiquement_vos_r_servations_et__viter_les_doublons_:
    "Ajoutez vos liens Airbnb pour synchroniser automatiquement vos réservations et éviter les doublons.",
  lien_de_l_annonce_airbnb: "Lien de l'annonce Airbnb",
  airbnb_ical_calendar_link: "Airbnb iCal calendar link",
  disponible_dans_param_tres_de_l_annonce_export_du_calendrier:
    "Disponible dans Paramètres de l'annonce Export du calendrier",
  enregistrer: "Enregistrer",
  veuillez_cliquer_sur__localiser__pour_valider_l_adresse_avant_de_continuer_:
    "Veuillez cliquer sur 'Localiser' pour valider l'adresse avant de continuer.",
  vous_devez__tre_connect__pour_publier_:
    "Vous devez être connecté pour publier.",
  id_manquant_apr_s_sauvegarde: "ID manquant après sauvegarde",
  erreur_upload_photo: "Erreur upload photo",
  erreur_sauvegarde_metadata_photos: "Erreur sauvegarde metadata photos",
  une_erreur_est_survenue_lors_de_la_sauvegarde:
    "Une erreur est survenue lors de la sauvegarde",
  quitter: "Quitter",
  modification: "Modification",
  cr_ation: "Création",
  _tape: "Étape",
  sur: "sur",
  sauvegarde_en_cours___: "Sauvegarde en cours...",
  retour: "Retour",
  sauvegarde___: "Sauvegarde...",
  mettre___jour: "Mettre à jour",
  publier_l_annonce: "Publier l'annonce",
  suivant: "Suivant",
  _tes_vous_s_r_de_vouloir_supprimer_cette_annonce__:
    "Êtes-vous sûr de vouloir supprimer cette annonce ?",
  impossible_de_supprimer_l_annonce__: "Impossible de supprimer l'annonce :",
  g_rez_vos_logements_et_leur_disponibilit__:
    "Gérez vos logements et leur disponibilité.",
  ajouter_une_annonce: "Ajouter une annonce",
  vous_n_avez_aucune_annonce: "Vous n'avez aucune annonce",
  commencez___gagner_un_revenu_en_louant_votre_logement__c_est_simple_et_rapide_:
    "Commencez à gagner un revenu en louant votre logement. C'est simple et rapide.",
  cr_er_ma_premi_re_annonce: "Créer ma première annonce",
  publi_: "Publié",
  brouillon: "Brouillon",
  __nuit: "/ nuit",
  voir_l_annonce: "Voir l'annonce",
  modifier: "Modifier",
  supprimer: "Supprimer",
  quels__quipements_proposez_vous__: "Quels équipements proposez-vous ?",
  s_lectionnez_tout_ce_qui_est_disponible_pour_les_voyageurs_:
    "Sélectionnez tout ce qui est disponible pour les voyageurs.",
  aucun_sch_ma_conversation_compatible_trouv_:
    "Aucun schéma conversation compatible trouvé.",
  logements_concern_s: "logements concernés",
  logement_non_pr_cis_: "Logement non précisé",
  erreur_lors_de_l_envoi_du_message_: "Erreur lors de l'envoi du message.",
  rechercher_une_conversation: "Rechercher une conversation",
  demandes_re_ues: "Demandes reçues",
  mes_demandes: "Mes demandes",
  aucune_demande_re_ue_: "Aucune demande reçue.",
  aucune_demande_envoy_e_: "Aucune demande envoyée.",
  photo_de_profil: "Photo de profil",
  localisation_non_pr_cis_e: "Localisation non précisée",
  listing_: "Listing:",
  en_ligne: "En ligne",
  vous: "Vous",
  _crivez_votre_message___: "Écrivez votre message...",
  s_lectionnez_une_conversation: "Sélectionnez une conversation",
  pour_commencer___changer: "pour commencer à échanger",
  logement_propos_: "Logement proposé",
  description_non_pr_cis_e: "Description non précisée",
  ch_: "ch.",
  voy_: "voy.",
  nuit: "nuit",
  prix_non_pr_cis_: "Prix non précisé",
  voir: "Voir",
  aucune_annonce_li_e___cette_conversation_:
    "Aucune annonce liée à cette conversation.",
  s_lectionnez_une_conversation_pour_voir_les_d_tails_:
    "Sélectionnez une conversation pour voir les détails.",
  bonjour: "Bonjour",
  voici_ce_qui_se_passe_sur_votre_compte_aujourd_hui_:
    "Voici ce qui se passe sur votre compte aujourd'hui.",
  annonces_en_ligne: "Annonces en ligne",
  nouveaux_messages: "Nouveaux messages",
  prochains__changes: "Prochains échanges",
  matching_section__o__je_veux_aller: "Matching section: Où je veux aller",
  ajoutez_jusqu__10_villes_avec_rayon_en_km_et_vos_dates_de_d_part_pour_recevoir_des_propositions_mieux_cibl_es_:
    "Ajoutez jusqu'à 10 villes avec rayon en km et vos dates de départ pour recevoir des propositions mieux ciblées.",
  configurer_mes_pr_f_rences: "Configurer mes préférences",
  pr_t___recevoir_vos_premiers_voyageurs__:
    "Prêt à recevoir vos premiers voyageurs ?",
  compl_tez_votre_profil_et_publiez_votre_premi_re_annonce_pour_commencer_____changer_votre_logement_avec_la_communaut__traveltrok_:
    "Complétez votre profil et publiez votre première annonce pour commencer à échanger votre logement avec la communauté TravelÉchange.",
  cr_er_mon_annonce: "Créer mon annonce",
  compl_ter_mon_profil: "Compléter mon profil",
  impossible_de_charger_vos_preferences_:
    "Impossible de charger vos préférences.",
  preferences_enregistrees_: "Préférences enregistrées.",
  impossible_d_enregistrer_vos_preferences_:
    "Impossible d’enregistrer vos préférences.",
  impossible_de_supprimer_votre_profil_:
    "Impossible de supprimer votre profil.",
  chargement_des_preferences___: "Chargement des préférences...",
  unites_de_distance: "Unités de distance",
  kilom_tres__km_: "Kilomètres (km)",
  format_europeen_par_defaut: "Format européen par défaut",
  miles__mi_: "Miles (mi)",
  format_anglo_saxon: "Format anglo-saxon",
  visibilite_du_profil: "Visibilité du profil",
  mettre_mon_profil_en_pause: "Mettre mon profil en pause",
  me_masquer_dans_les_resultats_de_recherche:
    "Me masquer dans les résultats de recherche",
  zone_sensible: "Zone sensible",
  suppression___: "Suppression...",
  supprimer_mon_profil: "Supprimer mon profil",
  pensez_a_enregistrer_vos_modifications_:
    "Pensez à enregistrer vos modifications.",
  enregistrement___: "Enregistrement...",
  enregistrer_les_preferences: "Enregistrer les préférences",
  impossible_de_charger_votre_profil_: "Impossible de charger votre profil.",
  profil_enregistr__partiellement__la_base_de_donn_es_doit__tre_mise___jour__migration_sql__:
    "Profil enregistré partiellement. La base de données doit être mise à jour (migration SQL).",
  profil_mis___jour_avec_succ_s_: "Profil mis à jour avec succès.",
  profil_non_enregistr___la_base_de_donn_es_doit__tre_migr_e__colonnes_manquantes__:
    "Profil non enregistré: la base de données doit être migrée (colonnes manquantes).",
  profil_non_enregistr___trop_de_colonnes_manquantes__lancez_la_migration_sql_:
    "Profil non enregistré: trop de colonnes manquantes. Lancez la migration SQL.",
  votre_base_de_donn_es_n_est_pas___jour__lancez_la_migration_sql_puis_r_essayez_:
    "Votre base de données n’est pas à jour. Lancez la migration SQL puis réessayez.",
  erreur_lors_de_la_mise___jour_: "Erreur lors de la mise à jour.",
  photo_de_profil_mise___jour_: "Photo de profil mise à jour.",
  erreur_upload_photo_: "Erreur upload photo.",
  photo_de_couverture_mise___jour_: "Photo de couverture mise à jour.",
  erreur_upload_couverture_: "Erreur upload couverture.",
  document_envoy__pour_v_rification_: "Document envoyé pour vérification.",
  erreur_lors_de_l_envoi_du_document_: "Erreur lors de l'envoi du document.",
  impossible_de_charger_votre_profil_pour_le_moment_:
    "Impossible de charger votre profil pour le moment.",
  mon_profil_h_te: "Mon profil hôte",
  identit___r_seaux_et_infos_de_matching:
    "Identité, réseaux et infos de matching",
  plus_votre_profil_est_complet__plus_le_moteur_peut_proposer_des_h_tes_compatibles_:
    "Plus votre profil est complet, plus le moteur peut proposer des hôtes compatibles.",
  compl_tude_du_profil: "Complétude du profil",
  couverture: "Couverture",
  photo_principale: "Photo principale",
  h_te_traveltrok: "Hôte DONKEY TRAVEL",
  localisation_non_renseign_e: "Localisation non renseignée",
  ajoutez_une_photo_large_pour_mieux_pr_senter_votre_univers_d_h_te_:
    "Ajoutez une photo large pour mieux présenter votre univers d'hôte.",
  destinations_cibl_es: "Destinations ciblées",
  dates_pr_vues: "Dates prévues",
  configurer___o__je_veux_aller__: "Configurer « Où je veux aller »",
  statut_identit_: "Statut identité",
  v_rifi_: "Vérifié",
  en_cours: "En cours",
  non_v_rifi_: "Non vérifié",
  ajoutez_une_pi_ce_d_identit__pour_renforcer_la_confiance_de_la_communaut__:
    "Ajoutez une pièce d'identité pour renforcer la confiance de la communauté.",
  envoyer_document: "Envoyer document",
  identit__et_contact: "Identité et contact",
  pr_nom: "Prénom",
  nom: "Nom",
  pseudo_public: "Pseudo public",
  email: "Email",
  t_l_phone: "Téléphone",
  r_seaux_et_liens: "Réseaux et liens",
  site_web: "Site web",
  localisation_et_mode_de_voyage: "Localisation et mode de voyage",
  pays_de_r_sidence: "Pays de résidence",
  s_lectionnez_un_pays: "Sélectionnez un pays",
  ville_de_r_sidence: "Ville de résidence",
  amiens: "Amiens",
  combien_de_personnes_voyagent__: "Combien de personnes voyagent ?",
  voyagez_vous_avec_des_animaux__: "Voyagez-vous avec des animaux ?",
  oui: "Oui",
  non: "Non",
  voyagez_vous_avec_des_b_b_s__: "Voyagez-vous avec des bébés ?",
  bio_h_te: "Bio hôte",
  pr_sentez_votre_style_d_accueil_et_votre_logement_:
    "Présentez votre style d'accueil et votre logement.",
  pr_sentation_de_la_famille: "Présentation de la famille",
  qui_voyage__habitudes__rythme__type_de_s_jour_recherch___:
    "Qui voyage, habitudes, rythme, type de séjour recherché...",
  compl_tez_aussi___o__je_veux_aller___pour_activer_un_matching_plus_pr_cis_:
    "Complétez aussi « Où je veux aller » pour activer un matching plus précis.",
  enregistrer_le_profil: "Enregistrer le profil",
  horizon_contrat: "Horizon contrat",
  "24_mois_apres_le_1er_sejour": "24 mois après le 1er séjour",
  nuits_que_je_dois: "Nuits que je dois",
  nuits_qu_on_me_doit: "Nuits qu'on me doit",
  echanges_ouverts: "Échanges ouverts",
  echanges_proches_echeance: "Échanges proches échéance",
  alerte_solde_des_echanges: "Alerte solde des échanges",
  aucun_profil_a_risque_detecte_pour_le_moment_:
    "Aucun profil à risque détecté pour le moment.",
  contrats_en_cours: "Contrats en cours",
  personne: "Personne",
  logement: "Logement",
  contrat: "Contrat",
  dates: "Dates",
  echange_effectue: "Échange effectué",
  solde_nuits: "Solde nuits",
  temps_restant: "Temps restant",
  "1er_sejour_": "1er séjour:",
  echeance_: "Échéance:",
  ils_sont_venus__fait: "Ils sont venus: fait",
  ils_sont_venus__en_attente: "Ils sont venus: en attente",
  je_suis_alle__fait: "Je suis allé: fait",
  je_suis_alle__en_attente: "Je suis allé: en attente",
  je_dois: "Je dois",
  nuits: "nuits",
  on_me_doit: "On me doit",
  carte_des_p_rim_tres_de_recherche: "Carte des périmètres de recherche",
  villes_localis_es: "villes localisées",
  mise___jour_de_la_carte___: "Mise à jour de la carte...",
  vous_devez__tre_connect__pour_g_rer_vos_pr_f_rences_:
    "Vous devez être connecté pour gérer vos préférences.",
  impossible_de_charger_vos_pr_f_rences_de_matching_pour_le_moment_:
    "Impossible de charger vos préférences de matching pour le moment.",
  ajoutez_au_moins_une_ville_cible_pour_activer_le_matching_:
    "Ajoutez au moins une ville cible pour activer le matching.",
  une_p_riode_a_une_date_de_fin_ant_rieure___la_date_de_d_part_:
    "Une période a une date de fin antérieure à la date de départ.",
  s_lectionnez_au_moins_un_pays_si_vous_activez_le_filtre_de_contact_par_pays_:
    "Sélectionnez au moins un pays si vous activez le filtre de contact par pays.",
  pr_f_rences_enregistr_es__les_pays_cibl_s_sont_conserv_s_localement_tant_que_la_migration_sql_n_est_pas_appliqu_e_:
    "Préférences enregistrées. Les pays ciblés sont conservés localement tant que la migration SQL n’est pas appliquée.",
  pr_f_rences_de_matching_enregistr_es_avec_succ_s_:
    "Préférences de matching enregistrées avec succès.",
  pr_f_rences_non_enregistr_es__base_non_migr_e__lancez_la_migration_sql_:
    "Préférences non enregistrées: base non migrée. Lancez la migration SQL.",
  erreur_lors_de_l_enregistrement_: "Erreur lors de l'enregistrement.",
  matching_intelligent: "Matching intelligent",
  indiquez_vos_villes_cibles_et_vos_p_riodes_de_d_part__traveltrok_pourra_proposer_les_h_tes_les_plus_compatibles_:
    "Indiquez vos villes cibles et vos périodes de départ: DONKEY TRAVEL pourra proposer les hôtes les plus compatibles.",
  retour_au_profil: "Retour au profil",
  villes_et_rayon_de_recherche: "Villes et rayon de recherche",
  jusqu___10_villes__ex__amiens_2_km__paris_5_km__lille_20_km__:
    "Jusqu'à 10 villes (ex: Amiens 2 km, Paris 5 km, Lille 20 km).",
  villes_actives: "villes actives",
  ville: "Ville",
  choisir_un_pays: "Choisir un pays",
  saisissez_une_ville: "Saisissez une ville",
  choisissez_le_pays_d_abord: "Choisissez le pays d'abord",
  rayon: "Rayon",
  supprimer_cette_ville: "Supprimer cette ville",
  ajouter_une_ville: "Ajouter une ville",
  ces_villes_seront_utilis_es_pour_proposer_des_changes_cibl_s_:
    "Ces villes seront utilisées pour proposer des échanges ciblés.",
  enregistrer_mes_pr_f_rences: "Enregistrer mes préférences",
  pays_d_europe___visiter: "Pays d'Europe à visiter",
  cochez_les_pays_qui_vous_int_ressent__vous_pouvez_ensuite_limiter_les_prises_de_contact___ces_pays_:
    "Cochez les pays qui vous intéressent. Vous pouvez ensuite limiter les prises de contact à ces pays.",
  pays_s_lectionn_s: "pays sélectionnés",
  tout_cocher: "Tout cocher",
  tout_d_cocher: "Tout décocher",
  _tre_contact__uniquement_par_les_membres_de_ces_pays:
    "Être contacté uniquement par les membres de ces pays",
  ce_filtre_sera_utilis__dans_votre_matching_automatique_:
    "Ce filtre sera utilisé dans votre matching automatique.",
  union_europ_enne: "Union européenne",
  hors_union_europ_enne: "Hors Union européenne",
  agenda_des_d_parts_souhait_s: "Agenda des départs souhaités",
  ajoutez_les_p_riodes_o__vous_souhaitez_partir_pour_lancer_un_matching_sur_des_cr_neaux_communs_:
    "Ajoutez les périodes où vous souhaitez partir pour lancer un matching sur des créneaux communs.",
  p_riode_s__active_s_: "période(s) active(s)",
  aucune_p_riode_ajout_e_pour_le_moment_:
    "Aucune période ajoutée pour le moment.",
  p_riode: "Période",
  supprimer_cette_p_riode: "Supprimer cette période",
  d_part: "Départ",
  commentaire__optionnel_: "Commentaire (optionnel)",
  ajouter_une_p_riode: "Ajouter une période",
  r_sum__matching: "Résumé matching",
  villes_cibles: "Villes cibles",
  rayon_moyen: "Rayon moyen",
  p_riodes_planifi_es: "Périodes planifiées",
  pays_cibl_s: "Pays ciblés",
  contacts_limit_s_aux_pays_coch_s: "Contacts limités aux pays cochés",
  contacts_ouverts___tous_les_pays: "Contacts ouverts à tous les pays",
  agenda_aper_u: "Agenda aperçu",
  ajoutez_une_p_riode_pour_afficher_votre_agenda_de_d_part_:
    "Ajoutez une période pour afficher votre agenda de départ.",
  sans_commentaire: "Sans commentaire",
  logement_traveltrok: "Logement DONKEY TRAVEL",
  localisation_a_preciser: "Localisation à préciser",
  logements_trouves: "logements trouvés",
  plus_recents: "Plus récents",
  capacite_max: "Capacité max",
  h_tes: "Hôtes",
  villes: "Villes",
  logements_disponibles: "Logements disponibles",
  pays_disponibles: "Pays disponibles",
  marie_accepte__: "Marie accepte !",
  nuits_a_reims_contre: "nuits a Reims contre",
  nuits_a_paris: "nuits a Paris",
  l_histoire_de_marie_jean: "L'histoire de Marie & Jean",
  "1__marie_consulte_l_agenda_de_jean": "1. Marie consulte l'agenda de Jean",
  elle_voit_que_jean_a_des_dates_libres_dans_2_semaines__parfait_pour_elle___jean_confirme_qu_il_peut_liberer_ces_dates_:
    "Elle voit que Jean a des dates libres dans 2 semaines. Parfait pour elle ! Jean confirme qu'il peut liberer ces dates.",
  h_tes_actifs: "Hôtes actifs",
  pays_couverts: "Pays couverts",
  echanges_realises: "Échanges réalisés",
  "100__match": "100% Match",
  echanges_longue_distance: "Échanges longue distance",
  matching_algorithmique_intelligent: "Matching algorithmique intelligent",
  notre_algorithme_croise_les_informations_de_votre_profil_et_de_vos_recherches_pour_vous_proposer_toutes_les_annonces_de_logements_qui_correspondent_exactement_a_votre_demande_:
    "Notre algorithme croise les informations de votre profil et de vos recherches pour vous proposer toutes les annonces de logements qui correspondent exactement à votre demande.",
  matching_precis: "Matching précis",
  analyse_intelligente_de_vos_crit_res: "Analyse intelligente de vos critères",
  gain_de_temps_dans_vos_recherches: "Gain de temps dans vos recherches",
  propositions_ultra_pertinentes: "Propositions ultra-pertinentes",
  habitants: "habitants",
  destinations_europeennes: "Destinations Européennes",
  decouvrez_les_merveilles_du_continent:
    "Découvrez les merveilles du continent",
  pays_actifs_sur_traveltrok: "Pays actifs sur DONKEY TRAVEL",
  selectionner_un_pays: "Sélectionner un pays",
  union_europeenne: "Union Européenne",
  hors_union_europeenne: "Hors Union Européenne",
  fiche_detaillee: "Fiche détaillée",
  selectionnez_un_pays_dans_la_liste_ou_sur_la_carte_pour_decouvrir_climat__population_et_lieux_emblematiques_:
    "Sélectionnez un pays dans la liste ou sur la carte pour découvrir climat, population et lieux emblématiques.",
  logements_actifs: "logements actifs",
  climat: "Climat",
  information_touristique: "Information Touristique",
  lieux_emblematiques: "Lieux emblématiques",
  gastronomie: "Gastronomie",
  dom_tom___outre_mer: "DOM-TOM / Outre-mer",
  villes_principales: "Villes principales",
  charte_officielle: "Charte officielle",
  confiance_mutuelle: "Confiance mutuelle",
  r_gles_claires: "Règles claires",
  sanctions_applicables: "Sanctions applicables",
  illustration_3d_des_engagements: "Illustration 3D des engagements",
  concept_3d_informations: "Image 3D des détails",
  principe_1: "Principe 1",
  v_racit__des_informations: "Véracité des informations",
  profil__logement__photos_et_prix_doivent__tre_exacts_:
    "Profil, logement, photos et prix doivent être exacts.",
  concept_3d_respect_du_lieu: "Image 3D du respect du lieu",
  principe_2: "Principe 2",
  respect_du_lieu: "Respect du lieu",
  aucune_f_te_et_z_ro_nuisance_pour_le_voisinage_:
    "Aucune fête et zéro nuisance pour le voisinage.",
  concept_3d_fiabilit__contractuelle: "Concept contractuel en 3D",
  principe_3: "Principe 3",
  fiabilit__contractuelle: "Fiabilité contractuelle",
  dates_bloqu_es___engagement_ferme__sauf_raison_valable_:
    "Dates bloquées = engagement ferme, sauf raison valable.",
  engagements_c_t__voyageur: "Engagements côté voyageur",
  engagements_c_t__h_te: "Engagements côté hôte",
  annulations_et_reports: "Annulations et reports",
  r_gle_op_rationnelle: "Règle opérationnelle",
  check_list_d_part_voyageur: "Check-list de départ",
  cuisine_et_vaisselle_propres: "Cuisine et vaisselle propres",
  sols_et_surfaces_rendus_propres: "Sols et surfaces rendus propres",
  linge_utilis__d_pos__selon_consigne: "Linge utilisé déposé selon consigne",
  aucune_invitation_non_autoris_e_pendant_le_s_jour:
    "Aucune invitation non autorisée",
  _tat_final_du_logement_confirm__avec_photos:
    "État final du logement confirmé",
  sanctions_en_cas_de_manquement: "Sanctions en cas de manquement",
  ce_que_permet_traveltrok: "Ce que permet DONKEY TRAVEL",
  vous_pouvez_inscrire_autant_de_logements_que_vous_voulez_:
    "Vous pouvez lister autant de logements que souhaité.",
  vous_pouvez__changer_autant_de_fois_que_vous_voulez_dans_l_ann_e_:
    "Échangez sans limite de récurrence au cours l'année.",
  chaque__change_repose_sur_un_contrat_clair_entre_deux_h_tes_:
    "Un contrat formel engage officiellement les hôtes et garantit le succès.",
  r_f_rences_de_bonnes_pratiques: "Références de bonnes pratiques",
  un_club_s_rieux__une_communaut__durable:
    "Un club sérieux crée une communauté durable",
  retour_au_guide_complet: "Retour au guide complet",
  carte_des_logements_traveltrok: "Carte des logements DONKEY TRAVEL",
  points_logements: "Points logements",
  aucune_donnee_geolocalisee_pour_le_moment_:
    "Aucune donnée géolocalisée pour le moment.",
  envie_d_entrer_dans_la_carte__: "Envie d'entrer dans la carte ?",
  chargement_des_logements___: "Chargement des logements...",
  la_date_d_arriv_e_est_requise: "La date d\\'arrivée est requise",
  la_date_ne_peut_pas__tre_dans_le_pass_:
    "La date ne peut pas être dans le passé",
  la_date_de_d_part_est_requise: "La date de départ est requise",
  la_date_de_d_part_doit__tre_apr_s_l_arriv_e:
    "La date de départ doit être après l\\'arrivée",
  le_message_doit_contenir_au_moins_10_caract_res:
    "Le message doit contenir au moins 10 caractères",
  veuillez_corriger_les_erreurs_ci_dessus:
    "Veuillez corriger les erreurs ci-dessus",
  une_erreur_est_survenue__veuillez_r_essayer_:
    "Une erreur est survenue. Veuillez réessayer.",
  paris__france: "Paris, France",
  mode_h_te: "Mode hôte",
  je_loue_quelques_semaines_par_an__le_mod_le_1eur___nuit_est_super_simple___expliquer_aux_voyageurs_:
    "Je loue quelques semaines par an. Le modèle 1EUR / nuit est super simple à expliquer aux voyageurs.",
  "37_nuits": "37 nuits",
  lyon__france: "Lyon, France",
  mode_voyageur: "Mode voyageur",
  la_r_servation_est_fluide__et_surtout_les_frais_sont_lisibles__je_compare_facilement_le_co_t_final_avant_de_confirmer_:
    "La réservation est fluide, et surtout les frais sont lisibles. Je compare facilement le coût final avant de confirmer.",
  "22_nuits": "22 nuits",
  bordeaux__france: "Bordeaux, France",
  "54_nuits": "54 nuits",
  marseille__france: "Marseille, France",
  pro_multi_logements: "Pro multi-logements",
  avec_plusieurs_biens__la_version_pro_me_fait_gagner__norm_ment_de_temps_sur_le_calendrier_et_la_gestion_des_demandes_:
    "Avec plusieurs biens, la version Pro me fait gagner énormément de temps sur le calendrier et la gestion des demandes.",
  "9_logements": "9 logements",
  retours_utilisateurs: "Retours utilisateurs",
  des_retours_terrain_concrets: "Des retours terrain concrets",
  des_voyageurs_et_h_tes_qui_veulent_une_location_plus_claire_et_plus_abordable_:
    "Des voyageurs et hôtes qui veulent une location plus claire et plus abordable.",
  activit_: "activité",
  _conomie_estim_e: "économie estimée",
  profils_et_logements_v_rifi_s: "Profils et logements vérifiés",
  exp_rience_location_simplifi_e: "Expérience location simplifiée",
  co_ts_transparents___la_nuit: "Coûts transparents à la nuit",
  marquer_des_dates: "Marquer des dates",
  je_peux_accueillir: "Je peux accueillir",
  je_veux_partir: "Je veux partir",
  partir_et_accueillir: "Partir et Accueillir",
  accueillir: "Accueillir",
  partir: "Partir",
  bloquer_les_dates: "Bloquer les dates",
  toujours_partir_et_accueillir: "Toujours Partir et Accueillir",
  rendre_ce_logement_visible: "Rendre ce logement visible",
  rendre_ce_logement_invisible: "Rendre ce logement invisible",
  confirmation_visibilite_logement:
    "Voulez-vous vraiment modifier la visibilité de CE logement pour les autres membres ?",
  confirmer_activer_toujours_partir_accueillir:
    "En activant ce mode, de nouvelles disponibilités 'Partir et Accueillir' seront ajoutées pour couvrir toujours les 2 prochaines années à partir d'aujourd'hui. Les autres disponibilités manuelles seront écrasées.\n\nÊtes-vous sûr de vouloir continuer ?",
  confirmer_desactiver_toujours_partir_accueillir:
    "Voulez-vous vraiment désactiver le mode 'Toujours Partir et Accueillir' ?",
  details_de_l_adresse__optionnel_: "Détails de l'adresse (optionnel)",
  rue_et_numero: "Rue et numéro",
  ex__12_rue_de_la_paix: "Ex: 12 rue de la Paix",
  appartement_suite: "Appartement, suite, etc.",
  ex__apt_4b: "Ex: Apt 4B",
  etage: "Étage",
  ex__3eme_sans_ascenseur: "Ex: 3ème",
  code_d_acces: "Code d'accès (porte/bâtiment)",
  ex__a1234: "Ex: A1234",
  ces_informations_ne_seront_partagees_qu_avec_les_voyageurs_confirmes:
    "Ces informations détaillées ne seront communiquées qu'aux membres ayant un échange confirmé avec vous.",
  lits_doubles: "Lits doubles",
  lits_simples: "Lits simples",
  canapes_lits: "Canapés-lits",
  lits_bebes: "Lits bébés",
  amenity_cat_essentials: "Les essentiels",
  amenity_cat_kitchen: "Cuisine et repas",
  amenity_cat_bathroom: "Salle de bain",
  amenity_cat_bedroom_laundry: "Chambre et linge",
  amenity_cat_entertainment: "Divertissement",
  amenity_cat_family: "Famille",
  amenity_cat_exterior: "Extérieur",
  amenity_cat_features: "Caractéristiques",
  amenity_cat_location: "Emplacement",
  amenity_cat_safety: "Sécurité",
  amenity_wifi: "Wifi",
  amenity_workspace: "Espace de travail dédié",
  amenity_ac: "Climatisation",
  amenity_heating: "Chauffage",
  amenity_kitchen: "Cuisine",
  amenity_refrigerator: "Réfrigérateur",
  amenity_microwave: "Micro-ondes",
  amenity_oven: "Four",
  amenity_dishwasher: "Lave-vaisselle",
  amenity_coffee_maker: "Machine à café",
  amenity_kettle: "Bouilloire",
  amenity_bathtub: "Baignoire",
  amenity_hair_dryer: "Sèche-cheveux",
  amenity_shampoo: "Shampooing et gel douche",
  amenity_hot_water: "Eau chaude",
  amenity_washing_machine: "Lave-linge",
  amenity_dryer: "Sèche-linge",
  amenity_iron: "Fer à repasser",
  amenity_hangers: "Cintres",
  amenity_bed_linens: "Linge de lit fourni",
  amenity_tv: "Télévision",
  amenity_game_console: "Console de jeux",
  amenity_books_toys: "Livres et jouets",
  amenity_sound_system: "Système audio",
  amenity_high_chair: "Chaise haute",
  amenity_baby_bath: "Baignoire bébé",
  amenity_travel_cot: "Lit parapluie",
  amenity_changing_table: "Table à langer",
  amenity_patio: "Balcon ou terrasse",
  amenity_garden: "Jardin privé",
  amenity_bbq: "Barbecue",
  amenity_outdoor_furniture: "Mobilier d'extérieur",
  amenity_pool: "Piscine",
  amenity_hottub: "Jacuzzi",
  amenity_gym: "Salle de sport",
  amenity_fireplace: "Cheminée",
  amenity_breakfast: "Petit-déjeuner inclus",
  amenity_parking: "Parking gratuit",
  amenity_ev_charger: "Borne de recharge pour VE",
  amenity_beachfront: "Accès plage",
  amenity_ski_in_out: "Accès aux pistes de ski",
  amenity_lake_access: "Accès lac",
  amenity_smoke_detector: "Détecteur de fumée",
  amenity_first_aid: "Kit de premiers secours",
  amenity_fire_extinguisher: "Extincteur",
  amenity_sauna: "Sauna",
  amenity_massage_chair: "Fauteuil de massage",
  amenity_shower: "Douche",
  amenity_home_cinema: "Home Cinéma",
  amenity_ping_pong: "Table de ping-pong",
  amenity_forest_access: "Accès à la forêt",
  amenity_hiking_access: "Accès à la randonnée",
  compl_t_: "complété",
  l_adresse_doit_tre_localis_e_sur_la_carte:
    "L'adresse doit être localisée sur la carte",
  au_moins_3_photos_requises: "Au moins 3 photos sont requises",
  le_titre_doit_faire_au_moins_10_caract_res:
    "Le titre doit faire au moins 10 caractères",
  la_description_doit_faire_au_moins_50_caract:
    "La description doit faire au moins 50 caractères",
  s_lectionnez_au_moins_3_quipements: "Sélectionnez au moins 3 équipements",
  encore_quelques_d_tails_avant_de_publier:
    "Encore quelques détails avant de publier",
  votre_annonce_est_compl_t_e_x:
    "Votre annonce est complétée à {{score}}%. Veuillez remplir les éléments manquants pour pouvoir la publier :",
  compl_ter: "Compléter",
  voici_comment_les_voyageurs_verront_votre_:
    "Voici comment les voyageurs verront votre annonce.",
  photo: "Photo",
  afficher_toutes_les_photos: "Afficher toutes les photos",
  h_t_par_vous: "• Hôte : Vous",
  description: "À propos de ce logement",
  votre_description_appara_tra_ici: "Votre description apparaîtra ici...",
  afficher_les_n__quipements_x: "Afficher les {{count}} équipements",
  ajouter_une_date: "Ajouter une date",
  aucun_montant_ne_vous_sera_d_bit_:
    "Aucun montant ne vous sera débité pour le moment",
  demander: "Demander",
  enregistrer_et_quitter: "Enregistrer et quitter",
  enregistrer_pour_plus_tard: "Enregistrer pour plus tard",
  conseils_pour_des_photos_r_ussies: "Conseils pour des photos réussies",
  privil_giez_le_format_paysage__1:
    "Privilégiez le format paysage (16:9) pour un meilleur affichage.",
  prenez_vos_photos_de_jour__avec_:
    "Prenez vos photos de jour, avec une bonne lumière naturelle.",
  rangez_et_nettoyez_les_pi_ces_av:
    "Rangez et nettoyez les pièces avant de les photographier.",
  mettez_en_avant_les_atouts_de_vo:
    "Mettez en avant les atouts de votre logement (vue, terrasse, beau salon...).",
  donnez_un_titre___votre_annonce: "Donnez un titre à votre annonce",
  un_titre_court_et_accrocheur_attirera_pl:
    "Un titre court et accrocheur attirera plus de voyageurs.",
  souhaite_visiter: "Souhaite visiter",
  vous_propose_en_change: "Vous propose en échange",
  autres_logements: "autres logements",
  voir_le_logement: "Voir le logement",
  votre_demande_titre: "Votre demande",
  votre_demande_soustitre:
    "Récapitulatif de vos envies de voyage et compagnons pour vos futurs échanges.",
  compagnons_de_voyage: "Compagnons de voyage",
  voyage_avec_bebe: "Bébé(s)",
  voyage_avec_animaux: "Animaux de compagnie",
  disponibilites_souhaitees: "Disponibilités souhaitées",
  destinations_cibles: "Destinations cibles",
  aucune_date_precisee: "Aucune date de voyage n'a été précisée.",
  aucune_destination_precisee: "Aucune destination cible n'a été précisée.",
  votre_demande_menu: "Votre demande",
  modifier_mon_profil: "Modifier mon profil",
  rayon_de: "Rayon de {{km}} km",
  dates_flexibles_option: "Dates flexibles",
  animaux_de_compagnie_details: "{{count}} animal/animaux",
  changer_d_annonce: "Changer d'annonce",
  profil_du_voyageur: "Profil du voyageur",
  chambres_requises: "Chambres requises",
  animaux: "animal(ux)",
  duree_du_sejour_souhaitee: "Durée du séjour souhaitée",
  combien_de_chambres_avez_vous_besoin__:
    "Combien de chambres avez-vous besoin ?",
  combien_de_b_b_s__: "Combien de bébés ?",
  combien__: "Combien ?",
  vos_animaux: "Vos animaux",
  chien_s_: "Chien(s)",
  plus_de_30_nuits: "Plus de 30 nuits",

  // Community Page
  "community.hero.badge": "Notre Communauté",
  "community.hero.title": "Rejoignez le réseau d'hôtes le plus authentique",
  "community.hero.subtitle":
    "Partagez plus que votre logement. Découvrez des histoires, rencontrez des hôtes passionnés et voyagez en toute confiance.",
  "community.stats.members": "Membres Actifs",
  "community.stats.countries": "Pays Représentés",
  "community.stats.exchanges": "Échanges Réalisés",
  "community.values.title": "Ce qui nous rassemble",
  "community.values.trust.title": "Confiance Absolue",
  "community.values.trust.desc":
    "Chaque membre est un hôte vérifié, garantissant le respect mutuel des lieux.",
  "community.values.sharing.title": "Partage & Rencontres",
  "community.values.sharing.desc":
    "L'opportunité de créer des liens avec des locaux partout en Europe.",
  "community.values.savings.title": "Économies Réelles",
  "community.values.savings.desc":
    "Voyagez plus souvent, plus loin, tout en préservant votre budget.",
  "community.testimonials.title": "Histoires de membres",
  "community.cta.title": "Prêt à faire partie de l'aventure ?",
  "community.cta.button": "Devenir membre aujourd'hui",

  // Blog Page
  "blog.hero.badge": "Notre Blog",
  "blog.hero.title": "Inspiration & Astuces",
  "blog.hero.subtitle":
    "Découvrez des histoires de voyage, des conseils pour préparer votre logement et les nouveautés du club.",
  "blog.categories.all": "Tous les articles",
  "blog.categories.tips": "Astuces Hôtes",
  "blog.categories.inspiration": "Inspiration Voyage",
  "blog.categories.news": "Actualités",
  "blog.empty": "Aucun article pour le moment. Revenez bientôt !",

  // Help Center
  "help.hero.badge": "Centre d'Aide",
  "help.hero.title": "Comment pouvons-nous vous aider ?",
  "help.hero.subtitle":
    "Trouvez des réponses rapides ou contactez notre équipe de support.",
  "help.search.placeholder": "Rechercher une réponse...",
  "help.categories.account.title": "Compte & Profil",
  "help.categories.account.desc":
    "Gérer vos informations, mots de passe et préférences.",
  "help.categories.exchanges.title": "Échanges & Réservations",
  "help.categories.exchanges.desc":
    "Comment proposer, accepter ou annuler un échange.",
  "help.categories.trust.title": "Confiance & Sécurité",
  "help.categories.trust.desc":
    "Contrats, vérification et protection des logements.",
  "help.faq.title": "Questions Fréquentes",
  "help.contact.cta": "Vous n'avez pas trouvé votre réponse ?",
  "help.contact.button": "Nous contacter",

  // Careers Page
  "careers.hero.badge": "Rejoignez l'équipe",
  "careers.hero.title": "Construisons l'avenir du voyage",
  "careers.hero.subtitle":
    "Nous recherchons des personnes passionnées pour redéfinir la façon dont les hôtes voyagent en Europe.",
  "careers.values.title": "Nos Valeurs",
  "careers.values.trust.title": "Humain et Confiance",
  "careers.values.remote.title": "Télétravail Flex",
  "careers.values.impact.title": "Impact Réel",
  "careers.openings.title": "Postes Ouverts",
  "careers.openings.empty":
    "Aucun poste actuellement ouvert. N'hésitez pas à envoyer une candidature spontanée !",
  "careers.apply.title": "Candidature Spontanée",
  "careers.apply.desc":
    "Envoyez votre CV et expliquez-nous comment vous pouvez aider Donkey Travel.",
  "careers.apply.button": "Envoyer ma candidature",

  // Contact Page
  "contact.hero.badge": "Contact",
  "contact.hero.title": "Nous sommes là pour vous",
  "contact.hero.subtitle":
    "Une question, une suggestion ou un problème ? Notre équipe est prête à vous écouter.",
  "contact.form.name": "Votre nom",
  "contact.form.email": "Votre e-mail",
  "contact.form.subject": "Sujet de votre message",
  "contact.form.message": "Votre message...",
  "contact.form.send": "Envoyer le message",
  "contact.info.title": "Informations Utiles",
  "contact.info.email": "contact@donkey.travel",
  "contact.info.address": "Vallée de la Haute-Somme, Picardie, France",
  "contact.info.hours": "Lun - Ven : 9h00 - 18h00",

  activez_votre_abonnement: "Activez votre abonnement",
  finalisez_votre_inscription: "! Finalisez votre inscription",
  _changes_illimit_s_en_europe: "Échanges illimités en Europe",
  validit___1_an: "Validité : 1 an",
  paiement_100__s_curis__par_paypal: "Paiement 100% sécurisé par PayPal",
  me_d_connecter_et_revenir_plus_tard: "Me déconnecter et revenir plus tard",
  erreur_lors_de_la_validation_du_paiement_sur_n:
    "Erreur lors de la validation du paiement sur nos serveurs.",
  le_paiement_n_a_pas_pu__tre_valid_: "Le paiement n'a pas pu être validé.",
  une_erreur_inconnue_est_survenue_lors_du_paiem:
    "Une erreur inconnue est survenue lors du paiement.",
  impossible_d_initialiser_paypal__v_rifiez_vot:
    "Impossible d'initialiser PayPal. Vérifiez votre connexion.",
  donn_es_personnelles: "Données personnelles",
  rejoignez_notre_communaut__et_r_servez_un_logement:
    "Rejoignez notre communauté et réservez un logement à {{city}} avec des frais fixes clairs et une assurance incluse.",
  bienvenue: "Bienvenue",
  code_promo_applique_avec_succes: "Code promo appliqué avec succès !",
  cible: "Cible",
  propose: "Propose",
  "1_sens": "1 sens",
  "2_sens": "2 sens",
  ils_veulent_visiter_votre_region_br_c_est_a_vous:
    "Ils veulent visiter votre région.<br />C'est à vous de découvrir où ils habitent !",
  ils_cherchent_chez_vous_et_br_ils_habitent_la_ou:
    "Ils cherchent chez vous ET<br />ils habitent là où vous voulez aller !",
  comment_ca_marche: "Comment ça marche ?",
  comprendre_les_differents_types_de_matching:
    "Comprendre les différents types de matching",
  match_reciproque: "Match réciproque",
  details_de_la_demande: "Détails de la demande",
  souhaite_venir_dans_votre_secteur: "Souhaite venir dans votre secteur :",
  peut_vous_accueillir: "Peut vous accueillir :",
  souhaite_visiter_dans_un_rayon:
    "Souhaite visiter <strong>{{city}}</strong> dans un rayon de <strong>{{radius}} km</strong>, votre logement correspond à sa recherche.",
  souhaite_visiter_ville:
    "Souhaite visiter <strong>{{city}}</strong>, votre logement correspond à sa recherche.",
  a_besoin_de_chambres: "A besoin de {{count}} chambre(s).",
  comparateur_de_valeur: "Comparateur de valeur",
  ecart: "écart",
  code_promo_invalide: "Code promo invalide",
  erreur_verification_code: "Erreur lors de la vérification du code",
  vous_avez_un_code_promo: "Vous avez un code promo ?",
  entrez_votre_code: "ENTREZ VOTRE CODE",
  appliquer: "Appliquer",
  // Step 1 additions
  importation_r_ussie_:
    "Importation réussie ! Vos informations ont été pré-remplies.",
  erreur_lors_de_l_importation: "Erreur lors de l'importation :",
  d_crivez_ce_qui_rend_votre_logement_uniq:
    "Décrivez ce qui rend votre logement unique...",
  mettez_en_avant_les_points_forts___votre:
    "Mettez en avant les points forts de votre logement",
  lien_annonce_airbnb_1: "Lien de votre annonce Airbnb",
  importation___: "Importation...",
  importer_l_annonce: "Importer l'annonce",
  renseignez_le_lien_de_votre_annonce_pou_:
    "Renseignez le lien de votre annonce. Vous pouvez importer les détails automatiquement pour gagner du temps.",
  lien_calendrier_airbnb: "Lien du calendrier (iCal)",
  nous_utiliserons_ce_lien_pour_synchroni:
    "Nous utiliserons ce lien pour synchroniser vos disponibilités.",
  sans_date_pr_cise: "Sans date précise",
  d_tails: "Détails",
  entrer_en_contact: "Entrer en contact",
  poli: "Poli",
  suppr_: "Suppr.",
  logement_s_: "logement(s)",
  souhaite_visiter: "Souhaite visiter",
  souhaite_visiter_dans_un_rayon:
    "Souhaite visiter <strong>{{city}}</strong> dans un rayon de <strong>{{radius}} km</strong>, votre logement correspond à sa recherche.",
  souhaite_visiter_ville:
    "Souhaite visiter <strong>{{city}}</strong>, votre logement correspond à sa recherche.",
  a_besoin_de_chambres: "A besoin de {{count}} chambre(s).",
  details_de_la_demande: "Détails de la demande",
  fermer: "Fermer",
  souhaite_venir_dans_votre_secteur: "Souhaite venir dans votre secteur :",
  peut_vous_accueillir: "Peut vous accueillir :",
  vous_propose_en_change: "Vous propose en échange",
  voir_le_logement: "Voir le logement",
  annonce_indisponible: "Annonce indisponible",
  autres_logements: "autres logements",
  cible: "Cible",
  propose: "Propose",
  attention___risque__lev__de_d_pendance_aux_voyages_gratuits__:
    "Attention : risque élevé de dépendance aux voyages gratuits !",
};
